/* eslint-disable no-unused-vars */
import moment from 'moment';
import React from 'react';
import { CSVLink } from 'react-csv';
import Xlxs from '../../../../../../../../assets/icons/Xlsx2';
import Table from '../../../../../../../../shared/components/Wrapper/Table';
import { convertToRealWithChecked } from '../../../../../../../../utils/values';
import { IExportCsv } from './interface';

function ExportCsv(props: IExportCsv) {
  const partnersValues = props.data.terceiros;
  const fiduciaValues = props.data.fiducia;

  const fileName = `Relatório Unificado de ${moment(
    props.data.dateSearch.start
  ).format('DD-MM-YY')} até ${moment(props.data.dateSearch.end).format(
    'DD-MM-YY'
  )}.csv`;

  const data = [
    {
      partnersType: 'Saldo',
      partnersLabels: 'SALDO INICIAL',
      partnersValues: convertToRealWithChecked(partnersValues.saldo_inicial),
      fiduciaType: 'Saldo',
      fiduciaLabels: 'SALDO INICIAL',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.saldo_inicial),
    },
    {
      partnersType: 'TED',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.teds.valor_recebido
      ),
      fiduciaType: 'TED',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.teds.valor_recebido
      ),
    },
    {
      partnersType: 'TED',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.teds.valor_enviado
      ),
      fiduciaType: 'TED',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.teds.valor_enviado),
    },
    {
      partnersType: 'PIX',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.pix.valor_recebido
      ),
      fiduciaType: 'PIX',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.pix.valor_recebido),
    },
    {
      partnersType: 'PIX',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.pix.valor_enviado
      ),
      fiduciaType: 'PIX',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.pix.valor_enviado),
    },
    {
      partnersType: 'Tarifas Pagas à Fidúcia',
      partnersLabels: 'Valor Enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.tarifas_pagas_a_fiducia.valor_enviado
      ),
      fiduciaType: '#',
      fiduciaLabels: '#',
      fiduciaValues: '#',
    },
    {
      partnersType: 'Tarifas Pagas à WL',
      partnersLabels: 'Valor Recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.tarifas_pagas_a_wl.valor_recebido
      ),
      fiduciaType: '#',
      fiduciaLabels: '#',
      fiduciaValues: '#',
    },
    {
      partnersType: 'Tarifas Pagas à WL',
      partnersLabels: 'Valor Enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.tarifas_pagas_a_wl.valor_enviado
      ),
      fiduciaType: '#',
      fiduciaLabels: '#',
      fiduciaValues: '#',
    },
    {
      partnersType: 'Tarifas pagas (PIX/TED/Outras)',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Tarifas pagas (PIX/TED/Outras)',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tarifas_pagas.valor_enviado
      ),
    },
    {
      partnersType: 'Tarifas pagas (TIB/SLB)',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Tarifas pagas (TIB/SLB)',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tarifas_tib_slb.valor_recebido
      ),
    },
    {
      partnersType: 'Tarifas pagas (TIB/SLB)',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Tarifas pagas (TIB/SLB)',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tarifas_tib_slb.valor_enviado
      ),
    },
    {
      partnersType: '#',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'FGTS',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.fgts.valor_recebido
      ),
    },
    {
      partnersType: 'Pagamento de Contas Celcoin',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.pagamentos_celcoin.valor_enviado
      ),
      fiduciaType: 'Pagamento de Contas Celcoin',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.pagamentos_celcoin.valor_enviado
      ),
    },
    {
      partnersType: 'Pagamento de Contas Celcoin',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.pagamentos_celcoin.valor_recebido
      ),
      fiduciaType: 'Pagamento de Contas Celcoin',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.pagamentos_celcoin.valor_recebido
      ),
    },
    {
      partnersType: '#',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Investimento',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.investimento.valor_recebido
      ),
    },
    {
      partnersType: 'Recebimento de TEV Interna',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.recebimento_tev_interna.valor_recebido
      ),
      fiduciaType: 'Recebimento de TEV Interna',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.recebimento_tev_interna.valor_recebido
      ),
    },
    {
      partnersType: 'Recebimento de TEV Interna',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.recebimento_tev_interna.valor_enviado
      ),
      fiduciaType: 'Recebimento de TEV Interna',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.recebimento_tev_interna.valor_enviado
      ),
    },
    {
      partnersType: 'Domicílio Bancário',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.domicilio_bancario.valor_recebido
      ),
      fiduciaType: 'Domicílio Bancário',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.domicilio_bancario.valor_recebido
      ),
    },
    {
      partnersType: 'Domicílio Bancário',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.domicilio_bancario.valor_enviado
      ),
      fiduciaType: 'Domicílio Bancário',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.domicilio_bancario.valor_enviado
      ),
    },
    {
      partnersType: 'Boletos',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.boletos_liquidados.valor_enviado
      ),
      fiduciaType: 'Boletos',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.boletos_liquidados.valor_enviado
      ),
    },
    {
      partnersType: 'Boletos',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.boletos_liquidados.valor_recebido
      ),
      fiduciaType: 'Boletos',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.boletos_liquidados.valor_recebido
      ),
    },
    {
      partnersType: 'TEVs',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.tev_entre_ambiente.valor_enviado
      ),
      fiduciaType: 'TEVs',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tev_entre_ambiente.valor_enviado
      ),
    },
    {
      partnersType: 'TEVs',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.tev_entre_ambiente.valor_recebido
      ),
      fiduciaType: 'TEVs',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tev_entre_ambiente.valor_recebido
      ),
    },
    {
      partnersType: 'Cartão',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.cartao.valor_enviado
      ),
      fiduciaType: 'Cartão',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cartao.valor_enviado
      ),
    },
    {
      partnersType: 'Cartão',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.cartao.valor_recebido
      ),
      fiduciaType: 'Cartão',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cartao.valor_recebido
      ),
    },
    {
      partnersType: 'Cripto',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.cripto.valor_enviado
      ),
      fiduciaType: 'Cripto',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cripto.valor_enviado
      ),
    },
    {
      partnersType: 'Cripto',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.cripto.valor_recebido
      ),
      fiduciaType: 'Cripto',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cripto.valor_recebido
      ),
    },
    {
      partnersType: 'Saldo Final',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(partnersValues.saldo_final),
      fiduciaType: 'Saldo Final',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.saldo_final),
    },
  ];

  const header = [
    { label: 'Terceiros: Tipo', key: 'partnersType' },
    { label: 'Terceiros: Operação', key: 'partnersLabels' },
    { label: 'Terceiros: Valores', key: 'partnersValues' },
    { label: '', key: '' },
    { label: 'Fidúcia: Tipo', key: 'fiduciaType' },
    { label: 'Fidúcia: Operação', key: 'fiduciaLabels' },
    { label: 'Fidúcia: Valores', key: 'fiduciaValues' },
  ];

  return (
    <CSVLink data={data} headers={header} filename={fileName}>
      <Table.Button>
        <Xlxs /> Download em Excel
      </Table.Button>
    </CSVLink>
  );
}

export default ExportCsv;
